import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from '../i18n/useTranslation';
import { TranslationKey } from '../i18n/en';

const SECTIONS: { title: TranslationKey; body: TranslationKey }[] = [
  { title: 'help.whatIsChat.title', body: 'help.whatIsChat.body' },
  { title: 'help.startChat.title', body: 'help.startChat.body' },
  { title: 'help.addMcpPortal.title', body: 'help.addMcpPortal.body' },
  { title: 'help.connectMcp.title', body: 'help.connectMcp.body' },
  { title: 'help.functionCalling.title', body: 'help.functionCalling.body' },
  { title: 'help.testMcp.title', body: 'help.testMcp.body' },
  { title: 'help.createProject.title', body: 'help.createProject.body' },
];

export default function HelpPage() {
  const t = useTranslation();

  return (
    <>
      <Box sx={{ mb: 5 }}>
        <Typography variant="h3" sx={{ mb: 1 }}>
          {t('help.page.title')}
        </Typography>
        <Typography variant="subtitle1">
          {t('help.page.subtitle')}
        </Typography>
      </Box>

      <Box sx={{ maxWidth: 800 }}>
        {SECTIONS.map((section) => (
          <Accordion
            key={section.title}
            disableGutters
            elevation={0}
            sx={{
              'border': '1px solid rgba(0,0,0,0.08)',
              'borderRadius': '12px !important',
              'mb': 1.5,
              '&:before': { display: 'none' },
              '&.Mui-expanded': { mb: 1.5 },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
                {t(section.title)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                {t(section.body)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </>
  );
}
